import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import Notifications from 'vue-notification'

import messages from '@/messages'
import Api from '@/services/Api'


Vue.use(VueI18n)
Vue.use(Notifications)

Vue.prototype.$api = new Api()

const i18n = new VueI18n({
  locale: 'en', 
  messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js